module.exports = __webpack_public_path__ + "32ef12152a8bfaee4ddf72d8218bfb80.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/wise-owl-wizard.png
// module id = 522
// module chunks = 0